var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.is.compareDrawerSelectorOpen
    ? _c("transition", { attrs: { name: "drawer" } }, [
        _c("section", { staticClass: "unum-drawer-compare-selector" }, [
          _c("div", { staticClass: "unum-drawer-compare-selector__head" }, [
            _c("div", { staticClass: "head__top" }, [
              _c(
                "span",
                {
                  staticClass: "menu-close",
                  on: { click: _vm.closeCompareDrawerSelectorEvent }
                },
                [_vm._v("Close Drawer")]
              ),
              _vm._v(" "),
              _c("h3", [_vm._v("Add a Platform")]),
              _vm._v(" "),
              this.filteredPlatforms.length > 0
                ? _c("p", [
                    _vm._v(
                      "\n          Based on your selections, these platforms align with your preferences. Select one to see its features.\n        "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "unum-drawer-compare-selector__search",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.search($event)
                  }
                }
              },
              [
                _c("unum-textbox", {
                  attrs: {
                    name: "lookupTerms",
                    label: "Search for a platform",
                    placeholder: "Search for a platform",
                    hideLabel: "",
                    noMargin: ""
                  },
                  model: {
                    value: _vm.lookupTerms,
                    callback: function($$v) {
                      _vm.lookupTerms =
                        typeof $$v === "string" ? $$v.trim() : $$v
                    },
                    expression: "lookupTerms"
                  }
                }),
                _vm._v(" "),
                _c("unum-button", { attrs: { color: "green" } }, [
                  _vm._v("Search")
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "unum-drawer-compare-selector__body" }, [
            _c("div", { staticClass: "body__v-bar-content" }, [
              _c("div", { staticClass: "body__content" }, [
                _c(
                  "section",
                  { staticClass: "results results--preferred" },
                  [
                    _c("header", { staticClass: "results__header" }, [
                      _c("h3", [_vm._v("Preferred")])
                    ]),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul", css: false },
                            on: {
                              "before-enter": _vm.resultsBeforeEnter,
                              enter: _vm.resultsEnter,
                              leave: _vm.resultsLeave
                            }
                          },
                          _vm._l(_vm.preferredPlatformsSorted, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.addPlatformEvent(platform)
                                        _vm.closeCompareDrawerSelector()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                  "
                                    ),
                                    _vm.is.dev
                                      ? _c(
                                          "span",
                                          { staticClass: "platform-priority" },
                                          [
                                            _vm._v(
                                              "\n                    priority: " +
                                                _vm._s(
                                                  _vm.platformPriority(
                                                    platform.priority
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.removePlatform(platform)
                                            _vm.closeCompareDrawerSelector()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "results results--fully-integrated" },
                  [
                    _c("header", { staticClass: "results__header" }, [
                      _c("h3", [_vm._v("Fully Integrated")])
                    ]),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul", css: false },
                            on: {
                              "before-enter": _vm.resultsBeforeEnter,
                              enter: _vm.resultsEnter,
                              leave: _vm.resultsLeave
                            }
                          },
                          _vm._l(_vm.fullyIntegratedPlatformsSorted, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.addPlatformEvent(platform)
                                        _vm.closeCompareDrawerSelector()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                  "
                                    ),
                                    _vm.is.dev
                                      ? _c(
                                          "span",
                                          { staticClass: "platform-priority" },
                                          [
                                            _vm._v(
                                              "\n                    priority: " +
                                                _vm._s(
                                                  _vm.platformPriority(
                                                    platform.priority
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.removePlatform(platform)
                                            _vm.closeCompareDrawerSelector()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "section",
                  { staticClass: "results results--future-integration" },
                  [
                    _c("header", { staticClass: "results__header" }, [
                      _c("h3", [_vm._v("Future Integration")])
                    ]),
                    _vm._v(" "),
                    _vm.results.length
                      ? _c(
                          "transition-group",
                          {
                            staticClass: "results__list",
                            attrs: { name: "results", tag: "ul", css: false },
                            on: {
                              "before-enter": _vm.resultsBeforeEnter,
                              enter: _vm.resultsEnter,
                              leave: _vm.resultsLeave
                            }
                          },
                          _vm._l(_vm.futureIntegrationPlatformsSorted, function(
                            platform,
                            index
                          ) {
                            return _c(
                              "li",
                              {
                                key: platform[".key"],
                                attrs: { "data-index": index }
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    attrs: {
                                      id: "key-" + platform[".key"],
                                      "data-platform-key": platform[".key"]
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.addPlatformEvent(platform)
                                        _vm.closeCompareDrawerSelector()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(platform.displayName) +
                                        "\n                  "
                                    ),
                                    _vm.is.dev
                                      ? _c(
                                          "span",
                                          { staticClass: "platform-priority" },
                                          [
                                            _vm._v(
                                              "\n                    priority: " +
                                                _vm._s(
                                                  _vm.platformPriority(
                                                    platform.priority
                                                  )
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isChosen(platform)
                                  ? _c(
                                      "unum-button",
                                      {
                                        attrs: {
                                          small: "",
                                          outline: "",
                                          color: "red"
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.removePlatform(platform)
                                            _vm.closeCompareDrawerSelector()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Remove\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1962b04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b1962b04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DrawerCompareSelector.vue
// module id = null
// module chunks = 